import { createContext, useContext, useState, ReactNode } from "react";
import { Edition, Duration } from "../../Settings";

// Optional pre-selection so a deeplink (e.g. from an email) can open the wizard
// straight on the plan/checkout step for a given tier.
export interface WizardPreselect {
    edition?: Edition;
    duration?: Duration;
    pcs?: number;
    // When set, the purchase upgrades an existing TRIAL key (same ident) instead of
    // issuing a new key — the trial's grant/base is converted to the bought tier.
    upgradeKeyIdent?: string;
}

interface WizardCtx {
    opened: boolean;
    preselect: WizardPreselect | null;
    openWizard: (preselect?: WizardPreselect) => void;
    closeWizard: () => void;
}

const WizardContext = createContext<WizardCtx | undefined>(undefined);

export function WizardProvider({ children }: { children: ReactNode }) {
    const [opened, setOpened] = useState(false);
    const [preselect, setPreselect] = useState<WizardPreselect | null>(null);
    const openWizard = (p?: WizardPreselect) => {
        setPreselect(p ?? null);
        setOpened(true);
    };
    const closeWizard = () => setOpened(false);
    return (
        <WizardContext.Provider value={{ opened, preselect, openWizard, closeWizard }}>
            {children}
        </WizardContext.Provider>
    );
}

export const useWizard = () => useContext(WizardContext);
